// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EditEntity from '../../components/CRUD/EditEntity';
import ValidationRulesBuilder, { buildValidationRules } from './ValidationRulesBuilder';

const UpdateDocumentType = () => {
  const buildUpdatePayload = (formValues) => {
    const payload: any = {
      code: formValues.code,
      en_name: formValues.en_name,
      ar_name: formValues.ar_name,
      // null clears rules, object sets them
      validation_rules: buildValidationRules(formValues),
    };
    return payload;
  };

  return (
    <EditEntity
      pageTitle="EditDocumentType"
      fetchApiUrl="/api/v1/web_portal/fare_media_policy_capping/document_types/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      inputs={[
        {
          name: 'code',
          labelKey: 'Code',
          inputType: 'text',
          required: true,
        },
        {
          name: 'en_name',
          labelKey: 'NameEnglish',
          inputType: 'text',
          required: true,
        },
        {
          name: 'ar_name',
          labelKey: 'NameArabic',
          inputType: 'text',
          required: true,
        },
        // Hidden input — makes EditEntity load validation_rules from fetched data into formValues
        {
          name: 'validation_rules',
          labelKey: 'ValidationRules',
          type: 'hidden',
        },
      ]}
      dropdowns={[]}
      buildUpdatePayload={buildUpdatePayload}
      updateApiUrl="/api/v1/web_portal/fare_media_policy_capping/document_types/:id"
      updateApiMethod="PATCH"
      successMessage="DocumentTypeUpdatedSuccessfully"
      successUrl="/fare-products/document-types"
      backUrl="/fare-products/document-types/:id"
      subsystemName="DocumentTypes"
      permissionSystem="fares"
      renderAboveSubmit={(formValues, setFormValues) => (
        <ValidationRulesBuilder
          formValues={formValues}
          setFormValues={setFormValues}
          initialRules={formValues.validation_rules}
        />
      )}
    />
  );
};

export default UpdateDocumentType;
